import React from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { baseTheme } from '../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderBottom: 'solid rgba(0, 0, 0, .2) 1px',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    lastRoot: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
    featureText: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
      fontSize: '1.5em',
      fontWeight: 'bold',
      textAlign: 'left',
    },
    releaseDateText: {
      paddingTop: theme.spacing(2),
      fontSize: '1.5em',
      fontWeight: 'bold',
      textAlign: 'center',
    },
  }),
);
export default function ComingFeaturePrimaryItem(props: any) {
  const { featureText, releaseText = null, releaseYear = '2025', last = false } = props;
  const classes = useStyles(baseTheme);
  return (
    <Grid container item xs={12} className={last ? classes.lastRoot : classes.root}>
      <Grid item xs={8} alignItems="center" justify="center">
        <Typography variant="h5" color="primary" className={classes.featureText}>
          {featureText}
        </Typography>
      </Grid>
      <Grid item xs={4 } alignItems="center">
        {releaseText &&
          <Typography variant="h5" color="primary" className={classes.releaseDateText}>
              {releaseText}
          </Typography>
        }
        {(releaseYear && !releaseText) &&
        <Typography variant="h5" color="primary" className={classes.releaseDateText}>
          Coming in {releaseYear}
        </Typography>}
      </Grid>
    </Grid>
  );
}
